<div v-if="comments.length > 0" class="tt-w-chatter">
  <div class="tt-w-chatter__heading" role="heading" :aria-level="chatterConfig.headingLevel" v-html="$msg('chatter.title')"></div>
  <tt-masonry-layout ref="layout" :breakpointsConfig="chatterConfig.breakpointsConfig" :class="'tt-w-chatter__list'">
    <tt-comment v-for="(comment, index) in comments"
                :comment="comment"
                :tileOrder="index"
                :isTile="true"
                :truncateLength="chatterConfig.truncateLength"
                :truncateAllowance="chatterConfig.truncateAllowance"
                :key="comment.id + '-' + currentPage"></tt-comment>
  </tt-masonry-layout>
  <tt-pagination :currentPage="currentPage" @updatePage="pageChange" :total="total" :pageSize="limit"></tt-pagination>
</div>